import { render, staticRenderFns } from "./case-allot.vue?vue&type=template&id=268949a0&scoped=true"
import script from "./case-allot.vue?vue&type=script&lang=ts"
export * from "./case-allot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268949a0",
  null
  
)

export default component.exports